import { useEffect, useState } from 'react';
import { BasePick } from '../domain/types';
import { loadPlayerPhotos } from '../services/playerPhotos';

export function PlayerPhoto({ pick, className = '' }: { pick: BasePick; className?: string }) {
  const [url, setUrl] = useState<string>();
  useEffect(() => {
    let alive = true;
    void loadPlayerPhotos([pick]).then(photos => { if (alive) setUrl(photos.get(pick.id)); });
    return () => { alive = false; };
  }, [pick.id, pick.player, pick.sport, pick.game]);
  const fallback = pick.sport === 'NBA' ? 'NBA' : 'NHL';
  return <span className={`player-photo ${className}`}>
    {url && <img src={url} alt="" loading="lazy" onError={() => setUrl(undefined)} />}
    {!url && <span aria-hidden="true">{fallback}</span>}
  </span>;
}
